import React, { ChangeEvent, createContext, Dispatch, SetStateAction, useMemo } from 'react';
import { SelectChangeEvent } from '@mui/material';
import { TFunction } from 'i18next';
import { useTrainingMaterial } from '../hooks/useTrainingMaterial';
import { User, Item, PrimaryCategoryStockCount, StockCheckItem, Store } from '../../../app/services/api/generated';
import { Blocker } from 'react-router';
import { TrainingAreaMaterials } from '../../../app/services/api/orderManagementClient';

export interface TrainingMaterialValues {
    t: TFunction<'createStockCount', undefined>,
    
    closeSnackBar: () => void,
    isSnackBarOpen: boolean,
    snackBarSeverity: 'error' | 'warning' | 'info' | 'success',
    snackbarMessage: string,
    snackBarDuration: number | null,
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    handleClose: () => void,
    openModal: () => void,
    loading: boolean,
    data: TrainingAreaMaterials[],
    deleteRow: (materialId: string, fileName: string) => Promise<void>,
    downloadFile: (fileName: string, blobName: string) => Promise<boolean>
    handleToggleSelection: (itemId: string) => void,
    handleBulkDelete: () => Promise<void>,  
    selectedStore: Store | null | undefined,
    hasWritePermission: boolean,
    selectedItems: string[],
    setSelectedItems: Dispatch<SetStateAction<string[]>>,
    filteredData: TrainingAreaMaterials[],
    searchQuery: string,  
    handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
   handleSaveAllFiles: () => Promise<void>
    handleFileSelection: (e: ChangeEvent<HTMLInputElement>) => void,
    removeFileFromPreview: (index: number) => void
    setPreviewOpen: Dispatch<SetStateAction<boolean>>,
    setSelectedFiles: Dispatch<SetStateAction<File[]>>,
    previewOpen: boolean,
    selectedFiles: File[],
    clearAll: () => void
}

export const TrainingMaterialContext = createContext<null | TrainingMaterialValues>(null);

interface ProviderProps {
  children: React.ReactNode;
}

export const TrainingMaterialProvider = ({ children }: ProviderProps) => {
  const {
    t,
    closeSnackBar,
    handleClose,
    isModalOpen,
    setIsModalOpen,
    openModal,
    isSnackBarOpen,
    snackBarSeverity,
    snackbarMessage,
    snackBarDuration,
    loading,
    data,
    deleteRow,
    downloadFile,
    handleToggleSelection,
    handleBulkDelete,
    selectedStore,
    hasWritePermission,
    selectedItems,
    setSelectedItems,
    filteredData,
    searchQuery,
    handleSearchChange,
    handleSaveAllFiles,
    handleFileSelection,
    removeFileFromPreview,
    setPreviewOpen,
    setSelectedFiles,
    previewOpen,
    selectedFiles,
    clearAll,

  } = useTrainingMaterial();

  const passedValue = {
    t,
    isModalOpen,
    closeSnackBar,
    handleClose,
    setIsModalOpen,
    openModal,
    isSnackBarOpen,
    snackBarSeverity,
    snackbarMessage,
    snackBarDuration,
    loading,
    data,
    deleteRow,
    downloadFile,
    handleToggleSelection,
    handleBulkDelete,
    selectedStore,
    hasWritePermission,
    selectedItems,
    setSelectedItems,
    filteredData,
    searchQuery,
    handleSearchChange,
    handleSaveAllFiles,
    handleFileSelection,
    removeFileFromPreview,
    setPreviewOpen,
    setSelectedFiles,
    previewOpen,
    selectedFiles,
    clearAll,

  };
  
  const fireBaseProviderValue = useMemo(() => ({ passedValue }), [passedValue]);

  return (
    <TrainingMaterialContext.Provider value={fireBaseProviderValue.passedValue}>
      {children}
    </TrainingMaterialContext.Provider>
  );
};